<template>
  <MyModal
    title="道路部署"
    height="auto"
    width="380px"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="road-content">
      <div class="adjust-desc-new">
        鼠标选中道路段可进行道路段调整
      </div>
      <div class="slope-area">
        <div class="manual-row">
          <div class="key">道路坡度</div>
          <div class="value">
            <StandInput
              v-model="slope"
              :onlyNumber="true"
              unit="度"
            ></StandInput>
          </div>
        </div>
      </div>
      <div class="entrance-area">
        <div class="my-title">
          入场点
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.entrance
              }
            ]"
            @click="
              () => {
                handleEntranceClick();
              }
            "
          ></i>
        </div>
        <div class="entrance-point">
          <div
            v-for="(item, index) in entrancePointList"
            :key="index"
            class="entrance-item"
          >
            <template v-if="!item.isEdit">
              <el-tag>入场点</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>纬度: {{ toFixed(item.lat, 6) }}</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag> 经度: {{ toFixed(item.lon, 6) }}</el-tag>
              <div class="btns">
                <!-- <i class="el-icon-view"></i> -->
                <i
                  class="el-icon-edit"
                  @click="handleEditEntrancePointClick(item)"
                ></i>
                <i
                  class="el-icon-delete"
                  @click="handleDelEntranceClick(item, index)"
                ></i>
              </div>
            </template>
            <template v-else>
              <el-tag> 入场点</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>
                <span class="mr-10">纬度:</span>
                <input
                  class="clean-input width-40"
                  v-model="item.lat"
                  type="text"
              /></el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>
                <span class="mr-10">经度:</span>
                <input
                  class="clean-input width-40"
                  v-model="item.lon"
                  type="text"
              /></el-tag>
              <div class="btns">
                <i
                  :class="['el-icon-check']"
                  @click="() => handleSaveEntrancePointClick(item, index)"
                ></i>
                <i
                  class="el-icon-close"
                  @click="() => handleCancelEntrancePointClick(item)"
                ></i>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="key-point">
        <div class="my-title">
          关键点
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.keyPoint
              }
            ]"
            @click="
              () => {
                handleKeyClick();
              }
            "
          ></i>
        </div>
        <div class="key-area">
          <div
            class="key-point-item"
            v-for="(item, index) in keyPointsList"
            :key="index"
          >
            <template v-if="!item.isEdit">
              <el-tag> 关键点{{ Number(index) + 1 }}</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>纬度: {{ toFixed(item.lat, 6) }}</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag> 经度: {{ toFixed(item.lon, 6) }}</el-tag>
              <div class="btns">
                <!-- <i class="el-icon-view"></i> -->
                <i
                  class="el-icon-edit"
                  @click="handleEditKeyPointClick(item)"
                ></i>
                <i
                  class="el-icon-delete"
                  @click="handleDelKeyPointClick(item, index)"
                ></i>
              </div>
            </template>
            <template v-else>
              <el-tag> 关键点{{ Number(index) + 1 }}</el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>
                <span class="mr-10">纬度:</span>
                <input
                  class="clean-input width-40"
                  v-model="item.lat"
                  type="text"
              /></el-tag>
              <el-divider direction="vertical"></el-divider>
              <el-tag>
                <span class="mr-10">经度:</span>
                <input
                  class="clean-input width-40"
                  v-model="item.lon"
                  type="text"
              /></el-tag>
              <div class="btns">
                <i
                  :class="['el-icon-check']"
                  @click="() => handleSaveKeyPointClick(item, index)"
                ></i>
                <i
                  class="el-icon-close"
                  @click="() => handleCancelKeyPointClick(item)"
                ></i>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- <div class="adjust-area" v-if="windfarmRoadList.length > 0">
        <template v-if="!specificEditFlag">
          <ct-button :btnClick="handleAdjustClick">调整</ct-button>
        </template>
        <template v-else>
          <span class="adjust-desc">请点击道路进行调整！</span>
          <ct-button type="primary" :btnClick="handleSaveRoadClick"
            >保存</ct-button
          >
          <ct-button :btnClick="handleAdjustClick">取消</ct-button>
        </template>
      </div> -->

      <div class="road-btn-area">
        <ct-button type="primary" :btnClick="handleDeployClick">
          开始部署
        </ct-button>
      </div>
      <div v-if="!!roadLength" class="manual-row">
        <el-tag> 道路长度:{{ roadLength + '米' }} </el-tag>
      </div>
    </div>
  </MyModal>
</template>

<script>
import MyModal from '../modal';
import { toFixed, booleanPointInPolygon } from '../utils';
import { mapGetters } from 'vuex';
import StandInput from '../stand-input';
import L from 'leaflet';
import entryPoint from '../images/entrypoint.svg';
import keyPointSrc from '../images/keypoint.svg';
export default {
  components: {
    MyModal,
    StandInput
  },
  computed: {
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'keyPointsList',
      'entrancePointList',
      'roadSlope',
      'windfarmRoadList',
      'roadLength',
      'specificEditFlag'
    ]),
    entranceObj() {
      return this.entrancePointList[0];
    }
  },
  data() {
    return {
      isShow: true,
      slope: null,
      keyPointStore: null,
      entranceStore: null
    };
  },
  watch: {
    roadSlope: {
      handler(val) {
        this.slope = val;
      },
      immediate: true
    },
    slope: {
      handler(val) {
        this.$store.commit('WindFarm/SET_ROADSLOPE', val);
      }
    }
  },
  created() {
    this.$bus.$on('createEntrancePoint', this.createEntrancePoint);
    this.$bus.$on('createKeypoint', this.createKeyPoint);
  },
  mounted() {
    this.handleAdjustClick();
  },
  beforeDestroy() {
    this.$bus.$off('createEntrancePoint', this.createEntrancePoint);
    this.$bus.$off('createKeypoint', this.createKeyPoint);

    this.handleKeyClick(false);
    this.handleEntranceClick(false);
    sessionStorage.removeItem('temp_polyGroup');

    // this.$store.commit('WindFarm/SET_RAW_MARKERS', {
    //   type: 'entrance',
    //   data: []
    // });

    // this.$store.commit('WindFarm/SET_RAW_MARKERS', {
    //   type: 'keypoint',
    //   data: []
    // });
  },
  methods: {
    handleEditEntrancePointClick(item) {
      item.isEdit = true;
      item.keyPointStore = {
        lat: item.lat,
        lon: item.lon
      };
    },
    handleSaveEntrancePointClick(item, index) {
      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([item.lat, item.lon], [poly]);

        if (!result) {
          return this.$message.warning('入场点必须在风场内部');
        }

        item.isEdit = false;

        const newArr = [...this.entrancePointList];
        newArr[index] = { ...item };

        this.$store.commit('WindFarm/SET_ENTRANCELISTS', [...newArr]);
        this.$store.commit('WindFarm/UPDATE_EXCLUSIVE_LIST');
      });
    },
    handleCancelEntrancePointClick(item) {
      item.isEdit = false;
      item.lat = item.keyPointStore.lat;
      item.lon = item.keyPointStore.lon;
    },
    handleEditKeyPointClick(item) {
      item.isEdit = true;
      item.keyPointStore = {
        lat: item.lat,
        lon: item.lon
      };
    },
    handleSaveKeyPointClick(item, index) {
      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([item.lat, item.lon], [poly]);

        if (!result) {
          return this.$message.warning('关键点必须在风场内部');
        }

        item.isEdit = false;

        const newArr = [...this.keyPointsList];
        newArr[index] = { ...item };

        this.$store.commit('WindFarm/SET_KEYPOINTS', [...newArr]);
        this.$store.commit('WindFarm/UPDATE_KEY_POINTS');
      });
    },
    handleCancelKeyPointClick(item) {
      item.isEdit = false;
      item.lat = item.keyPointStore.lat;
      item.lon = item.keyPointStore.lon;
    },
    handleSaveRoadClick() {
      this.$bus.$emit('roadSaveClick');
    },
    handleAdjustClick() {
      this.$nextTick(() => {
        this.$bus.$emit('resultClickDl');
      });
    },
    toFixed,
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 2);
    },
    createKeyPoint(data) {
      this.$store.commit('WindFarm/POP_MAP_POINT');
      const { lat, lng: lon } = data;

      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([lat, lon], [poly]);

        if (!result) {
          return this.$message.warning('关键点必须在风场内部');
        }

        const keyPoint = {
          lat,
          lon,
          isEdit: false,
          isShow: true
        };

        const keyArr = [...this.keyPointsList];

        keyArr.push(keyPoint);
        this.$store.commit('WindFarm/SET_KEYPOINTS', [...keyArr]);
        this.handleKeyClick(false);

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'keypoint',
          data: this.keyPointsList.map(i => {
            return {
              ...i,
              icon: keyPointSrc,
              iconSize: [15, 15],
              iconAnchor: [7.5, 15],
              lat: i.lat,
              lng: i.lon
            };
          })
        });
      });
    },

    createEntrancePoint(data) {
      const { lat, lng: lon } = data;
      this.$store.commit('WindFarm/POP_MAP_POINT');

      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([lat, lon], [poly]);

        if (!result) {
          return this.$message.warning('入场点必须在风场内部');
        }

        const entranceObj = {
          lat,
          lon,
          isEdit: false,
          isShow: true
        };

        const entranceArr = [entranceObj];

        this.$store.commit('WindFarm/SET_ENTRANCELISTS', [...entranceArr]);

        this.handleEntranceClick(false);

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'entrance',
          data: this.entrancePointList.map(i => {
            return {
              ...i,
              icon: entryPoint,
              iconSize: [15, 15],
              iconAnchor: [7.5, 15],
              lat: i.lat,
              lng: i.lon
            };
          })
        });
      });
    },

    handleDelKeyPointClick(item, index) {
      const keyArr = [...this.keyPointsList];
      keyArr.splice(index, 1);

      this.$store.commit('WindFarm/SET_KEYPOINTS', [...keyArr]);

      this.$store.commit('WindFarm/SET_RAW_MARKERS', {
        type: 'keypoint',
        data: keyArr.map(i => {
          return {
            iconSize: [15, 15],
            iconAnchor: [7.5, 15],
            icon: keyPointSrc,
            lat: i.lat,
            lng: i.lon
          };
        })
      });
    },
    handleDelEntranceClick() {
      this.$store.commit('WindFarm/SET_ENTRANCELISTS', []);

      this.$store.commit('WindFarm/SET_RAW_MARKERS', {
        type: 'entrance',
        data: []
      });
    },
    handleEntranceClick(value) {
      let status;
      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['entrance'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'entrance',
        value: !status
      });

      this.$bus.$emit('getMapInstance', map => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: require('../images/entrypoint.svg'),
            iconSize: [15, 15],
            iconAnchor: [7.5, 15]
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status
      });
    },
    handleKeyClick(value) {
      let status;
      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['keyPoint'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'keyPoint',
        value: !status
      });

      this.$bus.$emit('getMapInstance', map => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: require('../images/keypoint.svg'),
            iconSize: [15, 15],
            iconAnchor: [7.5, 15]
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status
      });
    },
    handleDeployClick() {
      if (!this.entranceObj) {
        return this.$message.warning('请添加一个入场点');
      }

      const keyPointsLat = this.keyPointsList.map(i => '' + i.lat);

      keyPointsLat.unshift('' + this.entranceObj.lat);
      const keyPointsLon = this.keyPointsList.map(i => '' + i.lon);

      keyPointsLon.unshift('' + this.entranceObj.lon);

      if (this.slope < 0 || this.slope > 90) {
        return this.$message.warning('道路坡度应大于等于0，小于等于90');
      }

      this.$postForm('/windfarm/windfarm/saveWindfarmRoad', {
        showError: true,
        showSuccess: true,
        showLoading: true,
        data: {
          windfarmId: this.$route.query.windfarmId,
          keyPointsLat: keyPointsLat.join(','),
          keyPointsLon: keyPointsLon.join(','),
          roadSlope: this.slope
        }
      }).then(() => {
        this.$store.dispatch('WindFarm/getRoadList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          },
          callback: () => {
            this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.mr-10 {
  margin-right: 5px;
}
.width-40 {
  font-size: 12px;
  height: 100%;
  width: 60px;
}
.road-content {
  padding: 5px 10px 10px 10px;
  .adjust-desc-new {
    font-weight: bold;
    color: #e07a27;
  }
  .adjust-desc {
    position: relative;
    font-size: 14px;
    font-weight: bold;
  }
  .adjust-area {
    margin-top: 10px;
    text-align: right;
    .ct-btn {
      margin-left: 5px;
    }
  }
  .entrance-area,
  .key-point {
    &:not(:first-child) {
      margin-top: 10px;
    }
    .my-title {
      font-weight: normal;
      font-size: 16px;
      color: #000;
      padding: 0px 10px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0px;
        top: 1px;
        border-radius: 3px;
        width: 5px;
        height: 100%;
        background-color: #015aac;
      }
      i {
        cursor: pointer;
        &:hover {
          color: #478beb;
        }
        &.is-active {
          color: #0159ac;
        }
      }
    }
    .entrance-point {
      display: flex;
      align-items: center;
      margin-top: 10px;
      padding: 0px 10px;

      .entrance-item {
        position: relative;
        display: flex;
        width: 100%;
        align-items: center;
      }
      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0px;
        i {
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover {
            color: #478beb;
          }
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }

    .key-area {
      margin-top: 10px;
      padding: 0px 10px;
      max-height: 120px;
      overflow: auto;

      .key-point-item {
        display: flex;
        align-items: center;
        position: relative;
        &:not(:first-child) {
          margin-top: 5px;
        }
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        right: -5px;
        i {
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover {
            color: #478beb;
          }
          &:nth-child(n + 2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
  .road-btn-area {
    margin-top: 10px;
    text-align: right;
  }
  .slope-area {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 7px;
    padding: 20px 20px 10px 20px;
    .manual-row {
      margin-bottom: 10px;
      display: flex;
      align-content: center;
      .key {
        margin-right: 5px;
        width: 60px;
        line-height: 30px;
        font-weight: 500;
      }
      .value {
        display: flex;
        align-items: center;
        width: 220px;
        font-size: 12px;
      }
    }
  }
}
</style>
